import React from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Segment, Grid, Header, Icon, Button } from "semantic-ui-react";
import { useIntl } from "react-intl";
import { ExternalSalesPartnerResource } from "../../../actions/externalSalesPartnerActions";
import { getExternalSalesPartners } from "../../../selectors/externalSalesPartners";
import ExternalSalesPartnerDialog from "./ExternalSalesPartnerDialog";

const ExternalSalesPartnerSegment = ({ projectId }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const resource = new ExternalSalesPartnerResource(dispatch, projectId);

  const partners = useSelector(getExternalSalesPartners);

  React.useEffect(() => {
    resource.fetchAll();
  }, []);

  return (
    <div>
      {partners.map(partner => {
        return (
          <Segment key={partner.id}>
            <Grid>
              <Grid.Column width={15}>
                <Header as="h5">
                  {partner.name ||
                    intl.formatMessage({
                      id:
                        "project.attributes.external_sales.partner_fallback_name"
                    })}
                </Header>
              </Grid.Column>
              <Grid.Column width={1} textAlign="right">
                <ExternalSalesPartnerDialog
                  trigger={<Icon name="edit" link />}
                  model={partner}
                  resource={resource}
                  projectId={projectId}
                />
              </Grid.Column>
            </Grid>
          </Segment>
        );
      })}
      <ExternalSalesPartnerDialog
        projectId={projectId}
        resource={resource}
        trigger={
          <Button
            icon="plus"
            basic
            content={intl.formatMessage({
              id: "project.attributes.external_sales.add_partner"
            })}
            fluid
          />
        }
      />
    </div>
  );
};

ExternalSalesPartnerSegment.propTypes = {
  projectId: PropTypes.number.isRequired
};

export default ExternalSalesPartnerSegment;
